export default __webpack_public_path__ + "static/media/ch2-title.8736cbbd.png";